// ink-component
import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { ButtonGroupWrapper } from './styles';

import getGlobalProps from '../../helpers/constants/global-props';

import ButtonGroupButton from './components/ButtonGroupButton/ButtonGroupButton';
import ButtonGroupToggle from './components/ButtonGroupToggle/ButtonGroupToggle';

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLUListElement> {
  /** Contents */
  children?: ReactNode;
  /** Vertically orient the buttons in the ButtonGroup */
  vertical?: boolean;
  /** Select the size variant to Buttons */
  size?: 'small' | 'auto';
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const globalProps = getGlobalProps({});

/**
 * @purpose ButtonGroup is used to group Buttons together.
 * @HTMLType HTMLUListElement
 * @categories navigation
 */
function ButtonGroup(props: ButtonGroupProps) {
  const { className, style, children, size, vertical, ...otherProps } = props;

  return (
    <ThemeProvider
      theme={theme => ({
        ...theme,
        vertical,
        size,
      })}
    >
      <ButtonGroupWrapper data-testid={props['data-testid']} role="list" size={size} {...otherProps} {...globalProps}>
        {children}
      </ButtonGroupWrapper>
    </ThemeProvider>
  );
}

ButtonGroup.Button = ButtonGroupButton;
ButtonGroup.Toggle = ButtonGroupToggle;

ButtonGroup.defaultProps = {
  'data-testid': undefined,
  vertical: false,
  toggle: false,
  size: 'auto',
};

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
